import { render, staticRenderFns } from "./SmplEdit.vue?vue&type=template&id=579fbfe4&scoped=true&"
import script from "./SmplEdit.vue?vue&type=script&lang=js&"
export * from "./SmplEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fbfe4",
  null
  
)

export default component.exports